import {
  PRODUCT_CATEGORY,
  Purchases,
  PURCHASES_ERROR_CODE,
} from '@revenuecat/purchases-capacitor'

/**
 * RevenueCat経由でアプリ内課金を実行する
 * この処理の中で、日本円による決済で、サーバーで保持している最新価格とRevenueCat(Apple/Google)の価格が一致しているかをチェックする
 *
 * @param productId - 購入する商品のID
 * @param apiKey - RevenueCatのAPIキー
 * @param expectedPriceJpy - 期待される価格（日本円）。サーバーで保持している最新価格
 * @param userId - ユーザーID（オプション）
 * @param isSubscription - サブスクリプション商品かどうか（オプション）
 * @param t - 翻訳関数（オプション）
 * @returns 購入結果
 * @throws エラーが発生した場合は適切なエラーメッセージをthrowする
 */
export const purchase = async (
  productId: string,
  apiKey: string,
  expectedPriceJpy: number,
  userId?: string,
  isSubscription?: boolean,
  t?: (key: string) => string
) => {
  await Purchases.configure({ apiKey, appUserID: userId })

  const product = await Purchases.getProducts({
    productIdentifiers: [productId],
    type: isSubscription
      ? PRODUCT_CATEGORY.SUBSCRIPTION
      : PRODUCT_CATEGORY.NON_SUBSCRIPTION,
  })

  if (!product?.products || product.products.length === 0) {
    throw new Error(t && t('iapProductNotPurchasable'))
  }

  // JPYのみ、サーバーで保持している期待価格（円）との一致を検証する
  // 外貨の場合は現状判定ができないのと利用数が少なく影響が小さいためスキップ
  const selectedProduct = product.products[0]
  if (
    selectedProduct?.currencyCode === 'JPY' &&
    expectedPriceJpy !== selectedProduct.price
  ) {
    throw new Error(t && t('iapPriceMismatch'))
  }

  const res = await Purchases.purchaseStoreProduct({
    product: product.products[0],
  }).catch(e => {
    switch (e?.code) {
      case PURCHASES_ERROR_CODE.PURCHASE_CANCELLED_ERROR:
        throw new Error(t && t('iapPurchaseCanceled'))
      case PURCHASES_ERROR_CODE.API_ENDPOINT_BLOCKED:
        throw new Error(t && t('iapApiBlocked'))
      case PURCHASES_ERROR_CODE.OFFLINE_CONNECTION_ERROR:
        throw new Error(t && t('iapOfflineError'))
      default:
        throw new Error(e?.error?.messsage ?? (t && t('iapPaymentFailed')))
    }
  })

  return res
}
